export const NEXTGEN_MAX_CONTENT_WIDTH = 1200;
